<template>
  <div v-if="checkingNum > 0" class="pa-3">
    <v-card>
      <v-card-text class="pt-0" style="display: flex;">
        <v-flex xs3>
          <div class="top_20">
            <v-btn @click="$router.push(routerLink)" fab large class="mouse" :color="color">
              <v-icon large>{{ icon }}</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs9 pr-3>
          <div>
            <div class="body-1 card_text_right text_grey" v-html="checkingMessage"></div>
            <div class="body-1 card_text_right text_grey" v-if="checkingArr">
              <div style="overflow:hidden;">
                <ul class="ul_style" v-for="(col, index) in checkingArr" :key="index">
                  <li class="li_style" v-for="(row, index) in col" :key="index">{{ row }}</li>
                </ul>
              </div>
            </div>
            <div class="display-1 card_text_right">{{ checkingNum }}</div>
          </div>
        </v-flex>
        </v-card-text>
        <template v-if="routerLink">
          <v-divider />
          <v-card-actions>
            <v-btn small :to="routerLink">
              <v-icon color="info" class="mr-1">build</v-icon>
              <span class="text-none">Fix</span>
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
  </div>
</template>

<script>
  export default {
    model: {
      prop: 'input',
      event: 'event',
    },
    props: {
      checkingMessage: {
        type: String,
        default: '',
      },
      checkingArr: {
        type: Array,
        default: () => [],
      },
      checkingNum: {
        type: String,
        default: '',
      },
      routerLink: {
        type: Object,
        default: null,
      },
      linkMessage: {
        type: String,
        default: '',
      },
      icon: {
        type: String,
        default: 'warning',
      },
      color: {
        type: String,
        default: 'yellow b_r_15',
      },
    },
    data() {
      return {
        output: '',
      }
    },
    mounted() {
      this.output = this.input
    },
    computed: {},
    watch: {
      output() {
        this.$emit('event', this.output)
      },
      input() {
        this.output = this.input
      },
    },
    methods: {},
  }
</script>

<style lang="stylus" scoped>
  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important;
  }

  .keep_space {
    white-space: pre;
  }

  .card_text_right {
    text-align: right;
  }

  .pl {
    padding-left: 3px;
  }

  .b_r_15 {
    border-radius: 15% !important;
  }

  .top_20 {
    position: relative;
    top: -20px;
  }

  .mouse {
    cursor: default !important;
    pointer-events: none;
  }

  .ul_style {
    float: right;
    padding-left: 14px;
  }

  .li_style {
    margin-left: 5px;
    margin-right: 5px;
    font-weight: 600;
    text-align: left;
  }
</style>